module.exports = __webpack_public_path__ + "media/images/front/footer/i3-acbdfa296d09f80e7f4447745811dac7.jpg";